import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../../css/Invoice.css";
import { useDispatch } from "react-redux"; // sử dụng dispatch
import { addToCart } from "../../../redux/cart/cartActions"; // import action
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import PaymentService from "../../../components/Service/NeoXService";
import { createPayPal } from "../../../components/Service/PaypalService";
import { updateWallet } from "../../../components/Service/Transaction";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import useLanguage from "../../../Hooks/useLanguage";
import { useTranslation } from 'react-i18next';
import { publicIpv4 } from "public-ip";

function InvoiceCSHP(props) {
    const location = useLocation();

    console.log("backup", props.backup)
    // console.log("selectedChildSystem", props?.selectednameversion)
    const paymentService = new PaymentService();

    const navi = useNavigate();
    const { onChildError } = props; // Nhận các props từ cha
    const [loading, setLoading] = useState(false);  // Trạng thái loading

    const [price, setPrice] = useState(null);
    const [usdPrice, setUsdPrice] = useState("0.00");
    const [billDetails, setBillDetails] = useState([]);
    const [checkeror, setcheckerro] = useState("");
    const [finalSubtotal, setFinalSubtotal] = useState(props?.baseAmount);
    const [tax, setTax] = useState(0);
    const [total, setTotal] = useState(0);
    const [searchParams] = useSearchParams();
    const [notify, setNotify] = useState(null);
    const [notifyerror, setNotifyerror] = useState(null);
    const [isBackupSelected, setIsBackupSelected] = useState(true);
    const [pricebackup, setpricebackup] = useState(props?.pricebackup)
    const [typeOrder, setTypeOder] = useState(null);
    const [checkCategory, setCheckCategory] = useState(false);

    const isCreatePage = location.pathname === '/wh-panel/create';
    useEffect(() => {
        if (isCreatePage) {
            setTypeOder("panel");
        }
    }, [isCreatePage]);
    useLanguage();
    const [ipAddress, setIpAddress] = useState("");

    const { t } = useTranslation();
    console.log("props?.pricebackup", props?.pricebackup)



    const calculateInvoiceDetails = () => {

        const taxRate = 0.1;
        let subtotal
        if (props?.backup?.isSelected == true) {
            subtotal = props?.packages?.cshp_price + props?.backup?.price;
        } else {
            subtotal = props?.packages?.cshp_price;
        }

        const taxAmount = subtotal * taxRate;

        const totalAmount = subtotal + taxAmount;

        return { subtotal, taxAmount, totalAmount };
    };

    useEffect(() => {

        const { subtotal, taxAmount, totalAmount } = calculateInvoiceDetails();
        setFinalSubtotal(subtotal);
        setTax(taxAmount);
        setTotal(totalAmount);

    }, [props.packages, props?.backupselected, props?.pricebackup]);
    useEffect(() => {
        const fetchIp = async () => {
            try {
                const ip = await publicIpv4();
                setIpAddress(ip);
            } catch (error) {
                console.error("Lỗi khi lấy IP:", error);
            }
        };
        fetchIp();
    }, []);


    const getCreditAndBalance = () => {
        const credit = parseFloat(localStorage.getItem('credit')) || 0;
        const balance = parseFloat(localStorage.getItem('Balance')) || 0;
        return { credit, balance };
    };

    const checkBalance = () => {
        const { credit, balance } = getCreditAndBalance();
        const totalAmount = props.packages?.cshp_price || 0;
        console.log("totalAmount", totalAmount)
        console.log("credit", credit);
        console.log("balance", balance);

        if (credit >= totalAmount || balance >= totalAmount) {
            return true;
        }
        // if (balance >= totalAmount && balance > 50000) {
        //     return true;
        // }
        else {
            return false;
        }
    };
    console.log("checkBalance", checkBalance())

    const serverchose = props?.selectedproduct;
    const image_id = props?.selectedChildSystem;
    useEffect(() => {
        console.log("image_id hiện tại:", image_id); // Thêm dòng này kiểm tra

        if (serverchose?.categories && Array.isArray(serverchose.categories) && image_id) {
            const filterImages = serverchose.categories.filter(category => category.type === "image");

            const category = filterImages.find(category =>
                category.images.some(image => image.id === Number(image_id)));
            setCheckCategory(category)
            console.log("category tìm được:", category);
        } else {
            console.warn("serverchose, categories hoặc image_id chưa có giá trị");
        }
    }, [serverchose, image_id]);
    // console.log("regions", props?.regions)
    const handleCreateOrder = async () => {
        const isCreatePage = location.pathname === '/wh-panel/create';

        console.log("isCreatePage", isCreatePage)

        const { credit, balance } = getCreditAndBalance();


        const package_id = props?.packages?.id;
        const domain_hosting_name = props?.hostname;
        const backup_id = props?.backupselected ? 1 : 0;
        const operating = props?.selectedChildSystem;
        const region_id = props?.regions?.id;
        // if (operating == null || checkCategory?.name == "WHPanel") {
        //     setcheckerro("You have not selected an Image");
        //     return;
        if (!typeOrder) {
            if (checkCategory?.name == "WHPanel") {
                setcheckerro("You have not selected an Image");
                return;
            } else if (!domain_hosting_name || domain_hosting_name.trim() === "") {
                console.log("hihi")
                const error = "You have not entered a hostname";
                setcheckerro(error);
                onChildError(error);
                return;
            }
        } else if (package_id == null) {
            setcheckerro("You have not selected a package");
            return;
        } else if (!domain_hosting_name || domain_hosting_name.trim() === "") {
            console.log("hihi")
            const error = "You have not entered a hostname";
            setcheckerro(error);
            onChildError(error);
            return;
        } else {
            setcheckerro("");
        }
        if (!checkBalance()) {
            setNotifyerror("Số dư trong tài khoản phải lớn hơn 50.000VND");

            setTimeout(() => {
                navi("/recharge");
            }, 2000);

            return;
        }
        const data = {
            package_id: package_id,
            currency: "VND",
            invoice_item_des: "Service Cshp",
            region_id: region_id,
            image_id: operating,
            backup_id: backup_id,
            domain_hosting_name: domain_hosting_name,
            ip_address: ipAddress,
            order_detail_des: "Service Cshp",
            type_order: typeOrder
        };

        try {
            setLoading(true);

            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/cshp-order/create`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${Cookies.get("Token")}`
                },
                body: JSON.stringify(data)
            });

            if (!response.ok) {

                const result = await response.json();
                if (result?.minBalance) {
                    setNotifyerror(`Số dư trong tài khoản phải lớn hơn ${result.minBalance} VND`);
                }
                setTimeout(() => {
                    navi("/recharge");
                }, 2000);
                throw new Error('Something went wrong!');


            }

            setNotify("Thanh toán thành công đơn hàng");
            localStorage.setItem("paymentSuccess", "true");
            setTimeout(() => {
                window.location.reload();
            }, 1000);

        } catch (error) {
            console.error('Error creating order:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (localStorage.getItem("paymentSuccess") === "true") {
            if (isCreatePage) {
                navi("/wh-panel");

            }
            else {
                navi("/cshp");

            }
            localStorage.removeItem("paymentSuccess");

        }
    }, [isCreatePage]);


    return (
        <div className="invoice-container p-3" style={{ background: "#f7faff", borderRadius: "8px" }}>

            {/* Hiển thị spinner nếu loading */}
            {loading && (
                <div className="spinner-overlay">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            )}
            <div className="summary-section">
                <h3 style={{ color: "#007bff", fontWeight: "bold", textAlign: "center", marginBottom: "30px", marginTop: "10px" }}>{t("Summary")}</h3>
                <div className="row summary-item mb-2">
                    <div className="col-5">{t("Plan")} <span style={{ fontSize: "12px" }}>{props?.package?.name}</span></div>
                    <div className="col-7 text-end">
                        {/* {props?.packages != null
                            ? props?.packages?.hour?.toLocaleString("vi-VN")
                            : "N/A"} */}
                        {props?.packages?.name}
                    </div>
                </div>
                <div className="row summary-item mb-2">
                    <div className="col-5">{t("CPU")} <span style={{ fontSize: "12px" }}>{props?.package?.name}</span></div>
                    <div className="col-7 text-end">
                        {/* {props?.packages != null
                            ? props?.packages?.hour?.toLocaleString("vi-VN")
                            : "N/A"} */}
                        {props?.packages?.core} vCore
                    </div>
                </div>
                <div className="row summary-item mb-2">
                    <div className="col-5">RAM <span style={{ fontSize: "12px" }}>{props?.package?.name}</span></div>
                    <div className="col-7 text-end">
                        {/* {props?.packages != null
                            ? props?.packages?.hour?.toLocaleString("vi-VN")
                            : "N/A"} */}
                        {props?.packages?.memory} GB
                    </div>
                </div>
                <div className="row summary-item mb-2">
                    <div className="col-5">NVMe <span style={{ fontSize: "12px" }}>{props?.package?.name}</span></div>
                    <div className="col-7 text-end">
                        {/* {props?.packages != null
                            ? props?.packages?.hour?.toLocaleString("vi-VN")
                            : "N/A"} */}
                        {props?.packages?.storage} GB
                    </div>
                </div>

                <div className="row summary-item mb-2">
                    <div className="col-4">Image</div>
                    <div className="col-8 text-end">
                        {props?.selectednameversion != null
                            ? props?.selectednameversion?.systemName
                            : "N/A"
                        }
                        <a style={{ marginLeft: '5px' }}>
                            {props?.selectednameversion?.version}
                        </a>
                    </div>

                </div>
                <div className="row summary-item mb-2">
                    <div className="col-4">{t("Price")}</div>
                    <div className="col-8 text-end">
                        {props?.packages?.cshp_price != null
                            ? props?.packages?.cshp_price.toLocaleString("vi-VN")
                            : "N/A"
                        }

                    </div>

                </div>

                <div className="row summary-item mb-2">
                    <div className="col-4">{t("Backup")}</div>
                    <div className="col-8 text-end">
                        {props?.backupselected == true
                            ? props?.pricebackup?.toLocaleString("vi-VN")
                            : 0
                        }

                    </div>

                </div>

                <hr />
                <div className="row summary-item mb-3">
                    <div className="col-6"><h4 style={{ fontSize: "17px" }}>{t("Subtotal")}</h4></div>
                    <div className="col-6 text-end">
                        {finalSubtotal ? finalSubtotal.toLocaleString("vi-VN") : "0"}

                    </div>
                </div>

                <div className="row summary-item mb-3">
                    <div className="col-6">{t("Tax")} (10%)</div>
                    <div className="col-6 text-end">
                        {tax.toLocaleString("vi-VN")}
                    </div>
                </div>
                <hr></hr>

                <div className="row summary-item mb-3">
                    <div className="col-6">
                        <h4 style={{ fontSize: "17px" }}>{t("Total Amount")}</h4>
                    </div>
                    <div className="col-6 text-end">
                        {props?.packages != null
                            ? total.toLocaleString('vi-VN')
                            : "N/A"}/h
                    </div>

                </div>

                <h5 style={{ color: "red", backgroundColor: "#f8d7da", fontSize: "14px", fontWeight: "bold", textAlign: "center" }} className="error-message">{checkeror}</h5>
                <h5 style={{ color: "green", backgroundColor: "#f8d7da", fontSize: "14px", fontWeight: "bold", textAlign: "center" }} className="error-message">{notify}</h5>
                <h5 style={{ color: "red", backgroundColor: "#f8d7da", fontSize: "14px", fontWeight: "bold", textAlign: "center" }} className="error-message">{notifyerror}</h5>

            </div>

            <div className="checkout-button-container mt-4 text-center">
                <button
                    className="checkout-button"
                    onClick={handleCreateOrder}
                    style={{
                        width: "100%",
                        fontFamily: "Arial, sans-serif",
                        fontSize: "16px",
                        fontWeight: "bold",
                        position: "relative"
                    }}
                    disabled={loading}
                >
                    {loading ? (
                        <>
                            <div className="spinner-border text-light" style={{ width: "1.5rem", height: "1.5rem", position: "absolute", left: "50%", transform: "translateX(-50%)" }} role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            Đang xử lý...
                        </>
                    ) : (
                        t('Deploy')
                    )}
                </button>
            </div>

        </div >
    );
}

export default InvoiceCSHP;
